import moment from 'moment';
import React, { useEffect, useState } from 'react';
import {
  Button,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Tooltip,
} from 'reactstrap';
import { fetchFollowUpForConceirge, markFollowUpCompletedForConceirge } from '../../services/api/conceirgeService';

const FetchFollowUpModal = (props) => {
  const { isOpen, closeFetchFollowUpModal, fetchFollowUpDetails, onComplete } = props;
  const [requestId, setRequestId] = useState('');
  const [followUps, setFollowUps] = useState([]);
  const [loading, setLoading] = useState(false);
  const [completedFollowUps, setCompletedFollowUps] = useState({});
  const [confirmedFollowUps, setConfirmedFollowUps] = useState([]);

  useEffect(() => {
    // Perform API call when the component mounts
    if (fetchFollowUpDetails) {
      console.log(fetchFollowUpDetails);
      setRequestId(fetchFollowUpDetails.requestId);
      getFollowUps(fetchFollowUpDetails.requestId); // api call to get all followUps for requestId
    }
}, [fetchFollowUpDetails]); // Equivalent to componentDidMount in class components

  const getFollowUps = () => {
    setLoading(true);
    const { conceirgeOrderId } = fetchFollowUpDetails;
    fetchFollowUpForConceirge(conceirgeOrderId)
      .then((response) => {
        setFollowUps(response.data);
      })
      .catch((err) => {
        console.log({ err });
      });

    setLoading(false);
  };

  const handleCheckboxChange = (followUpId) => {

    
    setCompletedFollowUps((prevState) => ({
        ...prevState,
        [followUpId]: !prevState[followUpId], // Toggle completion status
      }));
    setConfirmedFollowUps((prevFollowUps) => {
        if (prevFollowUps.includes(followUpId)) {
          return prevFollowUps.filter((id) => id !== followUpId);
        } else {
          return [...prevFollowUps, followUpId];
        }
      });
    
  };

  const confirmCompletedFollowUps = () => {
    //API call for confirmed follow-ups
    console.log(confirmedFollowUps,'confirmedFollowUps');
    const { conceirgeOrderId } = fetchFollowUpDetails;
    confirmedFollowUps.forEach((confirmedId) => {
      markFollowUpCompletedForConceirge(conceirgeOrderId,confirmedId);
    });

    // After API calls, reset the list of confirmed follow-ups
    getFollowUps(fetchFollowUpDetails.conceirgeOrderId);
    setConfirmedFollowUps([]);
    closeFetchFollowUpModal();
    onComplete();
  };

  return (
    <Modal
      isOpen={isOpen}
      onCancel={closeFetchFollowUpModal}
      toggle={closeFetchFollowUpModal}
    >
      <ModalHeader className="revamp-modal-header" toggle={closeFetchFollowUpModal}>
        Follow Ups ({requestId})
      </ModalHeader>
      <ModalBody>
        <div>
          <ListGroup>
            {followUps.map((item) => (
              <ListGroupItem key={item.followUpId}>
                <strong>Follow Up Reason:</strong> {item.reason}
                {' | '}
                <strong>Date and Time</strong>{' '}
                {moment(item.follow_up_datetime).format('YYYY-MM-DD hh:mm A')}
                {' | '}
                <input
                  type="checkbox"
                  id="completedCheckbox"
                  checked={completedFollowUps[item.followUpId] || false}
                  onChange={() => handleCheckboxChange(item.followUpId)}
                />
                <Tooltip placement="right" target="completedCheckbox">
                  {'Mark as Completed'}
                </Tooltip>
              </ListGroupItem>
            ))}
          </ListGroup>
        </div>
      </ModalBody>
      <ModalFooter style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-around',
          }}>
      <Button
          style={{
              backgroundColor: 'rgb(113, 79, 255)',
              width: '40%',
              borderColor: 'rgb(113, 79, 255)',
              height: '44px',
            }}
          //disabled={}
          onClick={confirmCompletedFollowUps}
        >
          Confirm
        </Button>
        <Button style={{
              backgroundColor: 'rgb(255, 255, 255)',
              width: '40%',
              borderColor: 'rgb(113, 79, 255)',
              color: 'rgb(113, 79, 255)',
              height: '44px',
            }} onClick={() => closeFetchFollowUpModal()}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default FetchFollowUpModal;
